import { listAnatomy as parts } from "../chakra/internal";
const baseStyleIcon = {
    marginEnd: '0.5rem',
    display: 'inline',
    verticalAlign: 'text-bottom'
};
const baseStyle = {
    container: {},
    item: {},
    icon: baseStyleIcon
};
const centerVariant = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        w: {
            base: '90%',
            md: '100%'
        },
        textAlign: {
            base: 'start',
            md: 'center'
        },
        alignItems: {
            base: 'start',
            md: 'center'
        }
    }
};
export const ThemedList = {
    parts: parts.keys,
    baseStyle,
    variants: {
        center: centerVariant
    }
};

//# sourceMappingURL=List.js.map